<form [formGroup]="behaviorForm" (ngSubmit)="onSubmit()" id="addBehaviorForm">
  <h2 class="form-title">{{ titleName }}</h2>

  <div class="control-row" id="behaviorName">
    <div class="control no-margin">
      <label for="patientBehaviorName">Behavior Name</label>
      <input class="form-control"
             type="text"
             id="patientBehaviorName"
             name="patientBehaviorName"
             formControlName="patientBehaviorName" />
    </div>
  </div>

  <div class="control-row no-margin" id="bspGoal">
    <div class="control" id="addBehaviorGoal">
      <label for="selectedBehaviorGoal">BSP Current Objective:</label>
      <p-dropdown class="ProgramBehaviorGoal-dropdown"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [panelStyle]="{maxWidth: '750px'}"
                  appendTo="body"
                  [options]="behaviorGoals"
                  formControlName="BSP_BehaviorGoalID"
                  name="selectedBehaviorGoal"
                  [checkmark]="true"
                  optionLabel="Goal"
                  optionValue="ID"
                  [showClear]="true"
                  placeholder="Select a BSP Current Objective"
                  id="addBehaviorGoalDropdown">
        <ng-template let-goalItem pTemplate="item">
          <div class="d-flex align-items-center gap-2">
            <div>
              <div class="picklist-label">{{goalItem.Behavior}}</div>
              <div class="d-block wrap-text">{{ goalItem.Goal }}</div>
            </div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  @if(canEditBip) {
    <div class="control-row">
      <div class="control no-margin">
        <p-checkbox inputId="includeInBip" formControlName="includeInBip" [binary]="true"></p-checkbox>
        <label for="includeInBip" class="ms-2">Include this behavior in the BIP</label>
        <small class="d-block">Turn this off for progress tracked outside the staff behavior intervention plan.</small>
      </div>
    </div>
  }

  <div class="control-row">
    <div class="control no-margin">
      <label for="targetType">Behavior Type:</label>
      <p-dropdown autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="patientBehaviorTypes"
                  formControlName="behaviorType"
                  optionValue="value"
                  optionLabel="text"
                  id="behaviorTypeDropdown"
                  (onClick)="onBehaviorTypeDropdownClicked()"
                  (onChange)="onBehaviorTypeChange($event)">
      </p-dropdown>
      @if(behaviorForm.controls.behaviorType.invalid &&
      behaviorForm.controls.behaviorType.touched) {
      <span class="control-error">Behavior Type is required.</span>
      }
    </div>
  </div>

  @if(shouldDisplayIntervalField()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="interval">Interval (in Minutes)</label>
      <p-inputNumber autoWidth="false"
                     [style]="{ width: '100%' }"
                     formControlName="intervalMinutes"
                     [showButtons]="true"
                     [minFractionDigits]="1"
                     [maxFractionDigits]="2" />
    </div>
  </div>
  }

  @if(shouldDisplayIntensityScaleFields()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="intensityScaleMin">Intensity Scale Min</label>
      <p-inputNumber autoWidth="false"
                     [style]="{ width: '100%' }"
                     formControlName="intensityScaleMin"
                     [showButtons]="true"
                     [min]="0"
                     [max]="100"
                     [minFractionDigits]="0"
                     [maxFractionDigits]="0" />
    </div>
    <div class="control no-margin">
      <label for="intensityScaleMax">Intensity Scale Max</label>
      <p-inputNumber autoWidth="false"
                     [style]="{ width: '100%' }"
                     formControlName="intensityScaleMax"
                     [showButtons]="true"
                     [min]="0"
                     [max]="100"
                     [minFractionDigits]="0"
                     [maxFractionDigits]="0" />
    </div>
  </div>
  <div class="control-row">
    <div class="control no-margin">
      <label for="intensityScaleValues">Custom Scale Values (optional)</label>
      <input class="form-control"
             type="text"
             id="intensityScaleValues"
             formControlName="intensityScaleValues"
             placeholder="e.g. 0, 2, 4, 8, 10" />
      <small>Leave blank to use every number from min to max. Enter specific numbers to skip values such as 6.</small>
    </div>
  </div>
  @if(isIntensityScaleLocked()) {
  <div class="control-row">
    <span class="control-error">The intensity scale cannot be changed because this behavior already has recorded data.</span>
  </div>
  }
  }

  <!-- Alarm Options - this will allow the user to select the alarm option and the alarm sound -->
  @if(shouldShowAlarmOptions()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="alarm">Alarm Options</label>
      <p-dropdown autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="alarmOptions"
                  formControlName="alarmOption" />
      <p-dropdown autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="alarmSounds"
                  formControlName="alarmSoundOption"
                  (onChange)="playAlarmSound($event)" />
    </div>
  </div>
  }

  @if(canEditBip) {
    <div class="control-row" id="operationalDefinition">
      <div class="control no-margin">
        <label for="operationalDefinitionEditor">Operational Definition</label>
        <div class="editor-container editor-container_classic-editor">
          <div class="editor-container__editor">
            <ckeditor
              id="operationalDefinitionEditor"
              name="operationalDefinition"
              [editor]="Editor"
              [config]="editorConfig"
              [data]="initialOperationalDefinition"
              (change)="onOperationalDefinitionChange($event)"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
  }

  <p class="actions" id="behaviorActions">
    <button type="button" (click)="onCancel()">Cancel</button>
    <button type="submit" id="saveBehaviorButton" [disabled]="saving">{{ actionName }}</button>
  </p>
</form>
